import { useEffect, useState } from "react";
import api from "@/api/client";

export default function MarketplaceTerms() {
  const [cfg, setCfg] = useState(null);
  useEffect(() => { api.get("/commission-config").then((r) => setCfg(r.data)).catch(() => {}); }, []);
  const slab1 = cfg ? cfg.slab1_pct : 18;
  const slab2 = cfg ? cfg.slab2_pct : 20;
  const threshold = cfg ? cfg.slab1_threshold : 1000;
  return (
    <div className="mx-auto max-w-3xl px-4 py-14" data-testid="marketplace-terms-page">
      <div className="text-xs uppercase tracking-[0.3em] text-[#F48E2E] font-bold mb-2">Policies</div>
      <h1 className="font-display text-4xl md:text-5xl mb-3">Marketplace Terms and Conditions</h1>
      <p className="text-gray-700 leading-relaxed mb-10">
        The following terms govern the relationship between Cityshor LLP (operator of CityShor Pop-Up Bazaar), the online exhibitors listed on the platform, and the buyers placing orders through it.
      </p>

      <div className="space-y-4">
        <Section title="1. Nature of the Marketplace">
          <p>CityShor Pop-Up Bazaar is an intermediary marketplace as defined under the Information Technology Act, 2000, and the Consumer Protection (E-Commerce) Rules, 2020. Cityshor LLP curates the daily drop, hosts the platform, processes payments and facilitates delivery. Cityshor LLP is not the manufacturer of the products listed.</p>
        </Section>
        <Section title="2. Contractual Relationship">
          <p>Every sale is a contract between the buyer and the online exhibitor (seller of record). Cityshor LLP acts as a facilitator, collects the payment on behalf of the exhibitor into the Cityshor LLP nodal account, and settles the exhibitor weekly after deducting the platform commission.</p>
        </Section>
        <Section title="3. Platform Commission">
          <p>A commission of {slab1} percent is deducted on orders up to ₹{threshold.toLocaleString("en-IN")}, and {slab2} percent on orders above that, based on the selling price of every product, deducted at settlement. The platform commission is subject to change with prior notice to exhibitors.</p>
        </Section>
        <Section title="4. Product Listings">
          <p>Exhibitors are solely responsible for the accuracy of their listings, including product images, description, size, colour, material, specifications, stock and price. Any misleading, counterfeit or non-compliant listing may be removed at Cityshor LLP's sole discretion.</p>
        </Section>
        <Section title="5. Order Fulfilment">
          <p>Exhibitors must ship the sold product directly to the customer within 24 hours via the Shiprocket shipment auto-created after order confirmation of the order notification. Shipping charges are handled by CityShor's Shiprocket integration and reconciled on the weekly payout. Repeated failure to ship on time may lead to suspension.</p>
        </Section>
        <Section title="6. Payments, Refunds and Chargebacks">
          <p>All payments are collected into the Cityshor LLP account, whether Cash on Delivery, Online (Razorpay), or Bank Transfer. Refunds arising from returns, cancellations or chargebacks are debited from the exhibitor's next weekly settlement.</p>
        </Section>
        <Section title="7. Taxes">
          <p>Cityshor LLP raises tax invoices on behalf of the marketplace under GSTIN 24AAPFC6216K1Z1 for all orders shipped from Gujarat. Intra-state orders attract CGST 9 percent and SGST 9 percent. Inter-state orders attract IGST 18 percent. Product prices displayed to buyers are inclusive of GST.</p>
        </Section>
        <Section title="8. Data and Privacy">
          <p>Buyer data (email, phone, address, city, gender, age) is collected only to fulfil orders and improve the buyer experience. Data is not sold. Exhibitors receive only the buyer's shipping name, address and phone through the platform.</p>
        </Section>
        <Section title="9. Prohibited Items">
          <p>Alcohol, tobacco, drugs, weapons, adult products, hate symbols, wildlife products, currency, and any item restricted or banned under Indian law are not permitted on the marketplace.</p>
        </Section>
        <Section title="10. Suspension and Removal">
          <p>Cityshor LLP reserves the right to suspend or permanently remove any exhibitor or listing without prior notice in case of fraud, counterfeit goods, repeated policy violations, or unresolved customer complaints.</p>
        </Section>
        <Section title="11. Meta Commerce Compliance">
          <p>The marketplace complies with the Meta Commerce Policies including genuine listings, transparent pricing, clear refund and return policies, accurate product descriptions, secure payments, customer support information and a no prohibited products commitment. See the Meta Commerce page for the full statement.</p>
        </Section>
        <Section title="12. Jurisdiction">
          <p>These terms are governed by the laws of India. Any dispute arising from the marketplace shall be subject to the exclusive jurisdiction of the courts of Ahmedabad, Gujarat.</p>
        </Section>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section className="p-6 bg-white rounded-2xl border border-gray-200">
      <h2 className="font-display text-2xl mb-2">{title}</h2>
      <div className="text-gray-700 leading-relaxed">{children}</div>
    </section>
  );
}
